import React from 'react';
import { Box } from '@mui/material';
import { APP_CONFIG } from '../../../../config/app.config';
import InventoryKpiCard from './InventoryKpiCard';
import SalesKpiCard from './SalesKpiCard';
import ServiceLevelKpiCard from './ServiceLevelKpiCard';

const DashboardSummaryCards: React.FC = () => {
  const colors = APP_CONFIG.ui.theme.colors;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' },
        overflow: 'hidden',
        border: `1px solid ${colors.border}`,
        '& > :not(:last-child)': {
          borderRight: { md: `1px solid ${colors.border}` },
          borderBottom: { xs: `1px solid ${colors.border}`, md: 'none' },
        },
        '& > :last-child': {
          borderRight: 'none',
        },
        borderRadius: '16px',
      }}
    >
      <SalesKpiCard />
      <ServiceLevelKpiCard />
      <InventoryKpiCard />
    </Box>
  );
};

export default DashboardSummaryCards;
